import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  logo: {
    width: 120,
  },
}));
